import { type FC } from "react";

import { TimeAgo, TriggerButton } from "widgets";

import { type ProjectActivity, type User } from "../../graphql.js";
import { ProjectActivityMessage } from "./ProjectActivityMessage.js";
import { getUserDisplayName, getUserTooltipDisplayName } from "@/modules/users/utils/user.js";

export interface IProjectActivityBodyProps {
  activity: ProjectActivity;
  users: User[];
  isCurrentUserActivity: boolean;
  onDeleteClicked?: (activity: ProjectActivity) => void;
}

export const ProjectActivityBody: FC<IProjectActivityBodyProps> = (props) => {
  return (
    <div className="inner">
      <div className="convo-headline">
        <p title={getUserTooltipDisplayName(props.activity.user)} className="sender">
          {props.isCurrentUserActivity ? "You" : getUserDisplayName(props.activity.user)}
        </p>
        &nbsp;
        <div className="datetime">
          <TimeAgo dateTimeISO={props.activity.created} />
        </div>
        {props.onDeleteClicked && props.activity.deletable && (
          <TriggerButton
            className={"delete"}
            icon={"delete"}
            label={"Delete comment"}
            onPress={() => props.onDeleteClicked(props.activity)}
          />
        )}
      </div>
      <span className="body">
        <ProjectActivityMessage activity={props.activity} users={props.users} forNotification={false} />
      </span>
    </div>
  );
};
